module.exports = __webpack_public_path__ + "img/imagen5.260af736.png";